<template>
  <div
  :class="[
  'element-select',
   { 'input-height': heightis40 },
   {'long-input': longSelect},
   {'width-64': width64}
   ]"
   :style="innerStyle">
      <div>{{label}}</div>
       <el-select
        v-model="value"
         :placeholder="$t('common.pleaseSelect')"
         @change="selectChange"
         >
    <el-option
      v-for="item in options"
      :key="item.value"
      :label="item.label"
      :value="item.value">
    </el-option>
  </el-select>
   <div v-if="!!bottomTip" class="bottom-tip">{{bottomTip}}</div>
  </div>
</template>

<script>
export default {
  props: {
    innerStyle: String,
    heightis40: Boolean,
    width64: Boolean,
    longSelect: Boolean,
    label: String,
    defaultValue: {
      type: String | Number,
      default: '',
    },
    options: {
      type: Array,
      default: () => [],
    },
    bottomTip: String,
  },
  data() {
    return {
      value: '',
    };
  },
  watch: {
    defaultValue(val) {
      this.value = val;
    }
  },
  methods: {
    selectChange(e) {
      this.$emit('selectValue', e);
    },
  },
};
</script>
<style lang="scss" scoped>
    .element-select {
        :first-child {
        font-family: PingFangSC-Semibold;
        font-size: 14px;
        color: #5A607F;
        letter-spacing: 0;
        margin-bottom: 4px;
        }
        .bottom-tip {
          font-family: PingFangSC-Semibold;
          font-size: 12px;
          color: #A1A7C4;
          letter-spacing: 0;
        }
    }

  .long-input {
     ::v-deep .el-input__inner {
        width: 567px;
    }
  }
  .width-64 {
     ::v-deep .el-input__inner {
        width: 94px;
    }
  }
  .input-height {
    ::v-deep .el-input__inner {
        height: 40px;
        width: 567px;
    }
  }
</style>
